import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=9d59cbfe&scoped=true&"
import script from "./AccountDetails.vue?vue&type=script&lang=js&"
export * from "./AccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d59cbfe",
  null
  
)

export default component.exports